import RouterView from '@/components/RouterView'
import TryoutHistoryList from './TryoutHistoryList'
import TryoutHistoryDetail from './TryoutHistoryDetail'

export default [
    {
        path: 'nilai',
        component: RouterView,
        children: [
            { path: '', component: TryoutHistoryList, name: 'grade', meta: { title: 'Nilai & Pembahasan' } },
            { path: ':history_hash', component: TryoutHistoryDetail, name: 'grade.detail', meta: { analyticsIgnore: true } },
        ]
    }
]
